import { render, staticRenderFns } from "./UserEmployee.vue?vue&type=template&id=3bf08377&scoped=true"
import script from "./UserEmployee.vue?vue&type=script&lang=js"
export * from "./UserEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf08377",
  null
  
)

export default component.exports